import React, { Fragment, useCallback, useEffect, useState } from 'react'

const BreadCrumb = ({ breadCrumbs: breadCrumbsValue, onGoBack, onClick, onChange, disableBackButton }) => {
    const [breadCrumbs, setBreadCrumbs] = useState([]);
  
    const goBack = useCallback(()=>{
      const newBreadCrumbs = [];
      setBreadCrumbs(newBreadCrumbs);
      onGoBack && onGoBack(newBreadCrumbs, breadCrumbs);
      onChange && onChange(newBreadCrumbs, breadCrumbs)
    },[breadCrumbs, onGoBack, onChange])
  
    const handleBreadCrumbClick = useCallback((item) => ()=>{
      const newBreadCrumbs = breadCrumbs.slice(0, breadCrumbs.findIndex(breadCrumb => breadCrumb.id === item.id) + 1)
      setBreadCrumbs(newBreadCrumbs)
      onClick && onClick(newBreadCrumbs, breadCrumbs)
      onChange && onChange(newBreadCrumbs, breadCrumbs)
    }, [breadCrumbs, onClick, onChange])
  
    useEffect(()=>{
      if(breadCrumbsValue && Array.isArray(breadCrumbsValue)){
        setBreadCrumbs(breadCrumbsValue)
      }
    },[breadCrumbsValue])
  
    return (
      <div className="bimmatch-breadcrumb bread-crumbs-container">
        <img src="/images/icon/arrow-left.svg" alt="left" className={`prev-arrow ${disableBackButton ? "disabled" : ""}`} onClick={goBack}/>
        {breadCrumbs.map((breadCrumb, index, arr) => (
          <Fragment key={breadCrumb.id}>
            <div>{index !== 0 ? "|" : ""}</div>
            {index === arr.length - 1 ? (
              <div>{breadCrumb.displayName}</div>
            ) : (
              <div
                className="link"
                onClick={handleBreadCrumbClick(breadCrumb)}
              >
                {breadCrumb.displayName}
              </div>
            )}
          </Fragment>
        ))}
      </div>
    )
}

export default BreadCrumb;